module.exports = __webpack_public_path__ + "static/img/rocket.c2897a5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gifs/rocket.gif
// module id = ouc2
// module chunks = 3